import { toDisplayString as _toDisplayString, createElementVNode as _createElementVNode, resolveComponent as _resolveComponent, createVNode as _createVNode, createTextVNode as _createTextVNode, openBlock as _openBlock, createElementBlock as _createElementBlock, createCommentVNode as _createCommentVNode } from "vue"

const _hoisted_1 = { class: "table table-striped border-light" }
const _hoisted_2 = { colspan: "2" }
const _hoisted_3 = { class: "mb-0 text-center text-capitalize-first" }
const _hoisted_4 = { class: "text-capitalize-first" }
const _hoisted_5 = { class: "text-capitalize-first" }
const _hoisted_6 = { class: "text-capitalize-first" }
const _hoisted_7 = { class: "text-capitalize-first" }
const _hoisted_8 = { key: 0 }
const _hoisted_9 = ["href"]
const _hoisted_10 = { key: 1 }

export function render(_ctx: any,_cache: any,$props: any,$setup: any,$data: any,$options: any) {
  const _component_copy_button = _resolveComponent("copy-button")!

  return (_openBlock(), _createElementBlock("table", _hoisted_1, [
    _createElementVNode("thead", null, [
      _createElementVNode("tr", null, [
        _createElementVNode("th", _hoisted_2, [
          _createElementVNode("h5", _hoisted_3, _toDisplayString(_ctx.helper.trans('labels.crypto_transaction')), 1)
        ])
      ])
    ]),
    _createElementVNode("tbody", null, [
      _createElementVNode("tr", null, [
        _createElementVNode("th", _hoisted_4, _toDisplayString(_ctx.helper.trans('labels.address.default')), 1),
        _createElementVNode("td", null, [
          _createTextVNode(_toDisplayString(_ctx.transaction?.address) + " ", 1),
          _createVNode(_component_copy_button, {
            value: _ctx.transaction?.address
          }, null, 8, ["value"])
        ])
      ]),
      _createElementVNode("tr", null, [
        _createElementVNode("th", _hoisted_5, _toDisplayString(_ctx.helper.trans('labels.sum')), 1),
        _createElementVNode("td", null, _toDisplayString(_ctx.numberFormatter.formatMoney(_ctx.transaction?.sum)), 1)
      ]),
      _createElementVNode("tr", null, [
        _createElementVNode("th", _hoisted_6, _toDisplayString(_ctx.helper.trans('labels.fee')), 1),
        _createElementVNode("td", null, _toDisplayString(_ctx.transaction?.fee ? _ctx.numberFormatter.formatMoney(_ctx.transaction?.fee) : 'n/a'), 1)
      ]),
      _createElementVNode("tr", null, [
        _createElementVNode("th", _hoisted_7, _toDisplayString(_ctx.helper.trans('labels.tx_id')), 1),
        _createElementVNode("td", null, [
          (_ctx.transaction?.txId)
            ? (_openBlock(), _createElementBlock("div", _hoisted_8, [
                _createElementVNode("a", {
                  href: _ctx.helper.explorerTx(_ctx.transaction?.sum.currency, _ctx.transaction.txId),
                  target: "_blank"
                }, _toDisplayString(_ctx.truncateTxId(_ctx.transaction.txId)), 9, _hoisted_9),
                _createVNode(_component_copy_button, {
                  class: "ms-1",
                  value: _ctx.transaction.txId
                }, null, 8, ["value"])
              ]))
            : (_openBlock(), _createElementBlock("div", _hoisted_10, " n/a "))
        ])
      ])
    ])
  ]))
}